import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { setLayoutState } from 'ducks/app'
import classNames from 'classnames'


const mapStateToProps = (state, props) => ({
  layoutState: state.app.layoutState,
})

@connect(mapStateToProps)
@withRouter
class LayoutState extends React.PureComponent {
  bootstrapLayoutSettings() {
    const { dispatch } = this.props
    const storageParams = JSON.parse(window.localStorage.getItem('app.layoutState'))
    if (storageParams) {
      delete storageParams.settingsOpened
    }
    const booleanMergedParams = JSON.parse(
      JSON.stringify(storageParams),
      (key, value) => (value === 'true' ? true : value === 'false' ? false : value),
    )
    dispatch(setLayoutState({ ...booleanMergedParams }))
  }

  componentWillMount() {
    this.bootstrapLayoutSettings()
  }

  componentWillReceiveProps(newProps) {
    this.updateBodyClass(newProps.layoutState)
  }

  updateBodyClass(layoutState) {
    document.body.className = classNames(layoutState)
  }
  
  render() {
    return null
  }
}

export default LayoutState



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Layout/LayoutState/index.js